import React from 'react';
import ChevronRightIcon from './ChevronRightIcon';
import EllipsisIcon from './EllipsisIcon';
export default function MoreBreadcrumbsMenu({ breadcrumbs }) {
    const [expanded, setExpanded] = React.useState(false);
    const moreMenuRef = React.useRef(null);
    const openMenuRef = React.useRef(null);
    React.useEffect(() => {
        function handleClickOutsideMenu(event) {
            if (moreMenuRef.current &&
                !moreMenuRef.current.contains(event.target) &&
                !openMenuRef.current?.contains(event.target)) {
                setExpanded(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutsideMenu);
        return () => {
            document.removeEventListener('mousedown', handleClickOutsideMenu);
        };
    }, [moreMenuRef]);
    return (React.createElement(React.Fragment, null,
        React.createElement("li", { className: 'cio-plp-parent-breadcrumb cio-plp-more-breadcrumbs-menu' },
            React.createElement("button", { id: 'cio-more-menu-button', "data-testid": 'cio-more-menu-button', type: 'button', "aria-haspopup": true, "aria-expanded": expanded, "aria-controls": 'cio-more-menu', ref: openMenuRef, onClick: () => {
                    setExpanded(!expanded);
                } },
                React.createElement(EllipsisIcon, null)),
            React.createElement("nav", { id: 'cio-more-menu', "data-testid": 'cio-more-menu', role: 'region', ref: moreMenuRef, "aria-labelledby": 'cio-more-menu-button', "aria-hidden": !expanded }, expanded && (React.createElement("ul", { role: 'menu' }, breadcrumbs.map((breadcrumbItem) => (React.createElement("li", { key: breadcrumbItem.path },
                React.createElement("a", { href: breadcrumbItem.path }, breadcrumbItem.breadcrumb)))))))),
        React.createElement(ChevronRightIcon, null)));
}
